<template>
  <el-container class="healthy page-x" direction="vertical">
    <div class="search-x">
      <div class="search-item">
        <span class="label">订单号</span>
        <el-input
          class="input-box"
          clearable
          placeholder="订单号"
          v-model.trim="searchBox.orderNo"
        >
        </el-input>
      </div>
      <div class="search-item">
        <span class="label">使用人信息</span>
        <el-input
          class="input-box"
          clearable
          placeholder="使用人姓名、手机号、用户ID"
          v-model.trim="searchBox.userInfo"
        >
        </el-input>
      </div>
      <div class="search-item">
        <span class="label">服务名称</span>
        <el-select v-model="searchBox.qnId" clearable>
          <el-option
            v-for="item in orderState"
            :value="item.value"
            :key="item.value"
            :label="item.label"
          >
          </el-option>
        </el-select>
      </div>
      <!-- <div class="search-item">
        <span class="label">完成状态</span>
        <el-select v-model="searchBox.status" clearable>
          <el-option value="1" label="已完成"> </el-option>
          <el-option value="0" label="未完成"> </el-option>
        </el-select>
      </div> -->
      <div class="search-item">
        <span class="label">作答时间</span>
        <el-date-picker
          v-model="timeCache.treatmentTime"
          @change="(e) => toChangeTime(e, 'beginTime', 'endTime')"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
      <el-button v-auth="'sa_order_page'" type="primary" @click="toSearch"
        >查询</el-button
      >
      <el-button
        v-auth="'sa_order_page'"
        type="primary"
        @click="() => ($root.showPage = false)"
        >重置</el-button
      >
      <el-button v-auth="'sa_order_export'" type="primary" @click="toView"
        >预览</el-button
      >
    </div>
    <p style="padding: 10px 0 30px 0">
      使用人次：{{ personTime }}人 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;使用次数：{{
        psersonNum
      }}次
    </p>
    <div class="cont-x">
      <div class="table-x" ref="tableBox">
        <el-table
          v-loading="loading"
          :data="tableData"
          :height="tableHeight"
          border
          class="mb20"
        >
          <el-table-column prop="orderNo" align="center" label="序号">
            <template slot-scope="scope">
              {{
                (searchBox.pageNo - 1) * searchBox.pageSize + scope.$index + 1
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="orderNo"
            align="center"
            label="订单号"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="qnName"
            align="center"
            width="160"
            label="服务名称"
          ></el-table-column>
          <el-table-column
            prop="usePerson"
            align="center"
            width="160"
            label="使用人"
          ></el-table-column>
          <el-table-column
            prop="mobile"
            align="center"
            width="160"
            label="手机号"
          ></el-table-column>
          <el-table-column
            prop="userId"
            align="center"
            width="160"
            label="用户ID"
          >
          </el-table-column>
          <el-table-column prop="state" align="center" label="状态" width="160">
            <template slot-scope="scoped">
              <span>{{ scoped.row.status === 0 ? "未完成" : "完成" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="updateTime"
            align="center"
            width="160"
            label="作答时间"
          ></el-table-column>

          <el-table-column
            prop="printNo"
            align="center"
            width="160"
            label="操作"
          >
            <template slot-scope="scope">
              <el-button
                size="middle"
                class="mb10"
                type="text"
                @click="toDetail(scope.row)"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pagenation-x">
      <div class="pagination mb20">
        <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :page-sizes="[10, 50, 100]"
          :current-page="searchBox.pageNo"
          :page-size.sync="searchBox.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
        >
        </el-pagination>
      </div>
    </div>
    <drag-dialog title="问卷预览" v-model="dialogVisible" v-if="dialogVisible">
      <div class="dialog-list">
        <div class="dialog-list-box">
          <el-tabs
            type="border-card"
            v-model="activeName"
            @tab-click="handleClick"
          >
            <el-tab-pane label="健康评估简易版" name="a">
              <div>
                <jianyiview />
              </div>
            </el-tab-pane>
            <el-tab-pane label="健康评估完整版" name="b">
              <div><wanzhengview /></div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </drag-dialog>
    <drag-dialog
      title="答题详情"
      v-model="xiangqingVisible"
      v-if="xiangqingVisible"
    >
      <img
        src="./../../assets/images/wancheng.jpeg"
        alt=""
        style="
          position: absolute;
          left: 70%;
          top: 60px;
          width: 100px;
          height: 100px;
          transform: rotate(45deg);
        "
      />
      <div class="dialog-list">
        <div class="dialog-list-box">
          <xiangqingview :row="row" />
        </div>
      </div>
    </drag-dialog>
  </el-container>
</template>

<script>
import dragDialog from "@/components/health/dragDialog.vue";
import jianyiview from "./jianyiview.vue";
import wanzhengview from "./wanzhengview.vue";
import xiangqingview from "./xiangqingview.vue";
import { dateFormat } from "@/assets/js/until.js";
import { cardType, relation, operation } from "@/assets/js/options";
import SelectAll from "@/components/SelectAll";
export default {
  name: "healthy",
  components: {
    dragDialog,
    SelectAll,
    jianyiview,
    wanzhengview,
    xiangqingview,
  },
  data() {
    return {
      psersonNum: 0,
      personTime: 0,
      row: null,
      xiangqingVisible: false,
      evaVisible: false,
      activeName: "a",
      cardType, // 证件类型list
      tableHeight: 0, // 表格高度
      orderState: [
        {
          value: 2122010001001,
          label: "健康评估完整版",
        },
        {
          value: 2122010002001,
          label: "健康评估简易版",
        },
      ], // 订单状态list （与公共状态不同步）
      relation, // 与权益人关系list
      operation, // 操作list
      // table表格
      loading: false,
      tableData: [], // table数据
      total: 0,
      // 查询条件
      timeCache: {}, // 时间缓存
      supplierList: [], // 供应商列表
      serviceList: [], // 服务项目名称列表
      statusArr: [],
      searchBox: {
        pageSize: 10,
        pageNo: 1,
        orderNo: "",
        userInfo: "",
        qnId: "",
        status: "",
        beginTime: "",
        endTime: "",
      }, // 搜索条件
      // 弹窗
      dialogVisible: false, // 弹窗visible
      // historicalTrack: [], // 订单状态历史轨迹
    };
  },
  mounted() {
    this.getServiceList();
    this.getSupplierList();
    this.getCountData();
    this.$nextTick(() => {
      this.listenWindow();
      this.getData();
    });
  },
  created() {
    // 面包导航
    this.$root.breadList = [
      { name: "服务订单", link: "" },
      { name: "健康体检订单", link: "" },
    ];
  },
  methods: {
    handleClick(tab) {
      if (tab.index === 0) {
        this.activeName = "a";
      } else {
        this.activeName = "b";
      }
    },
    //窗口改变，重新取得高度
    listenWindow() {
      this.tableHeight = this.$refs.tableBox.offsetHeight;
      window.addEventListener("resize", () => {
        clearTimeout(this.resizeFlag);
        this.resizeFlag = setTimeout(() => {
          try {
            this.tableHeight = this.$refs.tableBox.offsetHeight;
          } catch (error) {}
        }, 300);
      });
    },
    /**
     * 获取服务项目列表
     */
    async getServiceList() {
      let res = await this.axios.get(this.getApiUrl("medicalOrderItemList"), {
        params: {},
      });
      this.serviceList = res?.data || [];
    },
    /**
     * 获取供应商列表
     */
    async getSupplierList() {
      let res = await this.axios.get(
        this.getApiUrl("medicalOrderProviderList"),
        {
          params: {},
        }
      );
      this.supplierList = res?.data || [];
    },
    /**
     * 下载pdf
     */
    downPDF(url) {
      console.log(url);
      let cache = url.split("/");
      let name = cache[cache.length - 1].split(".");
      this.$root.exportFile(url, {}, name[0], "." + name[1]);
    },
    /**
     * 跳转详情
     */
    toDetail(row) {
      console.log(row);
      //查看某次答题详情
      this.row = row;
      this.xiangqingVisible = true;
    },
    /**
     * 问卷预览
     */
    async toView() {
      // 可tab切换的简易+完整问卷预览
      this.dialogVisible = true;
    },
    /**
     * 订单状态历史轨迹
     */
    // async getHistoricalTrack(id) {
    //   let res = await this.axios.get(
    //     this.getApiUrl("medicalOrderHistoricalTrack"),
    //     {
    //       params: { orderId: id },
    //     }
    //   );
    //   this.historicalTrack = res?.data || [];
    //   console.log(this.historicalTrack);
    // },
    /**
     * 搜索按钮
     */
    toSearch() {
      this.searchBox.pageNo = 1;
      this.getData();
      this.getCountData();
    },

    /**
     * 获取数据
     */
    async getData() {
      var params = { ...this.searchBox };

      const res = await this.axios.get(this.getApiUrl("evaCountList"), {
        params,
      });
      if (res.data) {
        this.tableData = res.data.list;
        this.total = res.data.total;
      }
    },
    /**
     * 获取统计字段
     */
    async getCountData() {
      var params = { ...this.searchBox };

      const res = await this.axios.get(this.getApiUrl("getCountData"), {
        params,
      });
      console.log(res);
      if (res.code == 1) {
        this.psersonNum = res.data.psersonNum;
        this.personTime = res.data.personTime;
      }
    },
    /**
     * 换页
     */ handleCurrentChange(val) {
      this.searchBox.pageNo = val;
      this.getData();
    },
    handleSizeChange(val) {
      this.searchBox.pageNo = 1;
      this.searchBox.pageSize = val;
      this.getData();
    },
    /**
     * 时间回调函数
     */
    toChangeTime(val, startName, endName) {
      console.log(val);
      if (val && val.length) {
        this.searchBox[startName] = dateFormat(val[0]) + " 00:00:00";
        this.searchBox[endName] = dateFormat(val[1]) + " 23:59:59";
      } else {
        this.searchBox[startName] = "";
        this.searchBox[endName] = "";
      }
    },
  },
  filters: {
    filterValue(text, data) {
      return (
        data.find((item) => {
          if (text === item.value) {
            return item;
          }
        })?.label || ""
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.cont-x {
  flex: 1;
  flex-shrink: 0;
  .table-x {
    height: 100%;
  }
}
.input-box-big {
  width: 250px;
}
</style>
